export default __webpack_public_path__ + "static/media/0x59e9261255644c411afdd00bd89162d09d862e38.c889f433.webp";